import api from "@/api";
import store from "@/store";
import * as Cookie from "js-cookie";
import { JSConn } from "./js-conn";

const tokenCheck = (token: string | boolean | null | undefined): boolean => {
  if (token) {
    if (token != "") {
      return true;
    }
  } else {
    return false;
  }

  return false;
};

export const tokenExists = () => {
  const token = localStorage.getItem("token");
  const cookieToken = Cookie.get("user_token");

  let apiToken: boolean | string | null | undefined = false;
  if (tokenCheck(token)) {
    apiToken = token;
  } else if (tokenCheck(cookieToken)) {
    apiToken = cookieToken;
  } else {
    apiToken = false;
  }
  return apiToken;
};

const updateSession = (jsConn: JSConn) => {
  const token = tokenExists();

  if (token) {
    jsConn.apiParams = { token: token };
    return api
      .updateSession(jsConn)
      .then(jsConn => {
        return store.dispatch("loadSessionData", jsConn);
      })
      .then(jsConn => {
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  } else {
    return Promise.reject(jsConn);
  }
};

export const session = {
  updateSession,
};
